module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "id": "vol-1-chapter-20"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "vol-1-chapter-20-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("20")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "vol-1-chapter-20-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("T")]), _vm._v("en thirty in the morning, and Black was in the meeting room – the largest room in the offices of Wilson, Fletcher and Co., east-facing, pale morning sunlight captured by three large windows."), _c('i'), _vm._v("One entire wall was dedicated to oak-panelled shelving for hundreds of law books, journals, reports, and in the centre a large rectangular walnut-veneered conference table with ten chairs round it, the surface gleaming. Black was sitting on one side, with three clients opposite, and between them were papers and plans and open files. The smell of fresh filtered coffee filled the room.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The door opened. Black turned. Rarely was anyone permitted to interrupt at a meeting, unless it was prearranged, or a secretary was bringing a file or a coffee.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Simon Fletcher stood at the doorway. He didn’t speak. He didn’t enter. He was ghastly pale. He looked shocked. His shirt collar was unbuttoned, his tie askew.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“What’s up, Simon?” asked Black, holding down sudden panic. Something was way wrong, his first thoughts Jennifer and Merryn.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Fletcher licked his lips, took a stuttering breath, but didn’t respond.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Excuse me,” said Black to the three people opposite, each reacting with looks of mild bemusement. He got up and made his way over to Fletcher who watched him approach with a glazed faraway stare.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Fletcher stepped back into the hallway; Black followed, closing the door behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“What the hell’s the matter, Simon?” asked Black, his voice low, strained.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I got a call from John Wilson this morning,” replied Fletcher, in a brittle voice. He kept swallowing, the muscles in his jaw clenching, unclenching. His eyes wouldn’t fix on Black but darted left and right. "), _c('i', [_vm._v("He’s scared,")]), _vm._v(" thought Black.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“John Wilson?” Black was trying to grasp the problem. The last name he was expecting to hear was that of his retiring partner. “And?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I didn’t know what to do. I’ve never seen anything like it. I… don’t know what to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Black had no option – he grabbed Fletcher by the shoulders and shook him.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Speak to me, Simon!”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Fletcher seemed to wake out of a trance. He took a deep breath.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“John Wilson is dead.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f26bcd1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vol001chapter020.vue
// module id = 132
// module chunks = 0